import React, { ReactNode } from 'react'
import { Col, Row } from 'react-bootstrap'

export interface MeetingScoreInsightsProps {
  scoreInsights: string[]
  insightType: string
  icon: ReactNode
}

export const MeetingScoreInsights: React.FC<MeetingScoreInsightsProps> = ({ scoreInsights, insightType, icon }) => {
  return (
    <Col className='d-flex zocks-p-1.25 gap-3 zocks-border-1.0 zocks-bg-color-gray-100 flex-column align-items-start'>
      <Row className='w-100'>
        <Col xs='auto' className='pe-0 pb-0'>
          {icon}
        </Col>
        <Col>
          <h6>{insightType}</h6>
        </Col>
      </Row>
      <Row className='gap-3'>
        {scoreInsights.map((item, index) => (
          <Row className='align-items-start zocks-gap-0.75' key={`insight.${index}`}>
            <Col className='pe-0' xs='auto'>
              <span className='mt-1 text-black'>•</span>
            </Col>
            <Col className='p-0'>
              <div>{item}</div>
            </Col>
          </Row>
        ))}
      </Row>
    </Col>
  )
}
